import React from "react";
import { Star } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { commonLabels } from "@/i18n";

const HeroBadge = () => {
  const { language } = useLanguage();
  const labels = commonLabels(language);
  const badgeText =
    labels.menuPages?.sellCar?.hero?.badge ||
    "Sveriges Smartaste Bilförsäljning";

  return (
    <div className="flex justify-center mb-8">
      <div className="bg-gradient-to-r from-emerald-500 to-cyan-500 text-white px-6 py-3 rounded-full shadow-lg backdrop-blur-sm border border-white/20">
        <div className="flex items-center gap-2 text-sm md:text-base font-semibold">
          <Star className="w-4 h-4 fill-yellow-300 text-yellow-300" />
          <span>{badgeText}</span>
          <Star className="w-4 h-4 fill-yellow-300 text-yellow-300" />
        </div>
      </div>
    </div>
  );
};

export default HeroBadge;
